export const swipePower = (offset: number, velocity: number) =>
  Math.abs(offset) * velocity;
